import React from "react";
import type { SectionComponentProps } from "../../registry.js";

interface HeroMinimalProps {
  headline?: string;
  subheadline?: string;
  ctaLabel?: string;
  ctaTarget?: string;
  eyebrow?: string; // small label above headline (e.g. "Est. 1987")
}

export function HeroMinimal({ props }: SectionComponentProps) {
  const {
    headline = "Welcome",
    subheadline,
    ctaLabel,
    ctaTarget = "#reservations",
    eyebrow,
  } = props as HeroMinimalProps;

  return (
    <section className="flex flex-col items-center justify-center text-center min-h-[50vh] px-6 py-24 bg-background">
      {eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-4">
          {eyebrow}
        </p>
      )}
      <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-foreground mb-6">
        {headline}
      </h1>
      {subheadline && (
        <p className="text-lg text-muted-foreground max-w-xl mb-10">{subheadline}</p>
      )}
      {ctaLabel && (
        <a
          href={ctaTarget}
          className="inline-flex items-center justify-center border-2 border-primary rounded-[var(--radius)] px-8 py-3 text-sm font-semibold text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
        >
          {ctaLabel}
        </a>
      )}
    </section>
  );
}
